import React from 'react';
import { Link } from 'react-router-dom';
import './Homepage.css'; // We will create this file for Homepage specific styles

function Homepage() {
  return (
    <div className="homepage">
      <section className="hero-section text-center">
        <div className="container">
          <h1>Your Complete Astrology & Numerology Toolkit</h1>
          <p className="hero-subtitle">
            Unlock the secrets of your life's path, personality, and potential through ancient wisdom.
          </p>
          <p>
            <Link to="/calculators" className="btn btn-primary">Explore All Calculators</Link>
          </p>
        </div>
      </section>

      <section className="bhagyank-intro my-8">
        <div className="container">
          <h2 className="text-center text-primary">What is Bhagyank (Destiny Number)?</h2>
          <p>
            Your Bhagyank, also known as your Destiny Number, is one of the most important numbers in numerology.
            It reveals your life's purpose, the lessons you are here to learn, and the path you are destined to follow.
            It's calculated from your full date of birth and represents the overall journey of your life.
            Understanding your Bhagyank can provide profound insights into your strengths, weaknesses, and the opportunities that await you.
          </p>
          <p>
            It guides you towards your true calling and helps you align with your higher self. By knowing your Bhagyank,
            you can make more informed decisions, understand your innate talents, and navigate challenges with greater clarity.
          </p>
        </div>
      </section>

      {/* Future sections for other astrology/numerology topics */}
    </div>
  );
}

export default Homepage;
